import Brace from "backbone.brace";
import { types } from "../config/alerts";
import _ from "underscore";

const Model = Brace.Model.extend({
  namedAttributes: {
    type: String,
    icon: String,
    message: String,
    autoDismiss: Boolean,
    autoDismissTimeout: Number,
  },

  defaults: {
    type: "info",
    icon: null, // calculated below in validate()
    message: null,
    autoDismiss: true,
    autoDismissTimeout: 5000,
  },

  validate(attrs) {
    // process required fields
    if (_.isEmpty(attrs.type) || _.isEmpty(attrs.message)) {
      return "Required fields are missing from alert message model.";
    }

    // validate type (and grab its icon)
    const icon = types[this.getType()];
    if (icon) {
      // when valid, set the icon
      this.setIcon(icon);
    } else {
      return "The requested alert type is invalid.";
    }
  },
});

export { Model as default };
